module.exports = __webpack_public_path__ + "static/img/icon15.bff41ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/image/index/icon15.png
// module id = Ty4c
// module chunks = 1